export function checkWebPSupport(src: string): Promise<boolean> {
  return new Promise((resolve) => {
    const webP = new Image();
    webP.onload = () => resolve(webP.width > 0 && webP.height > 0);
    webP.onerror = () => resolve(false);
    webP.src = src;
  });
}
